import { render, staticRenderFns } from "./OFooter.vue?vue&type=template&id=3d9b581a&scoped=true&"
import script from "./OFooter.vue?vue&type=script&lang=js&"
export * from "./OFooter.vue?vue&type=script&lang=js&"
import style0 from "./OFooter.vue?vue&type=style&index=0&id=3d9b581a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b581a",
  null
  
)

export default component.exports